var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8301 104.06C85.9215 104.06 103.83 86.1514 103.83 64.06C103.83 41.9686 85.9215 24.06 63.8301 24.06C41.7387 24.06 23.8301 41.9686 23.8301 64.06C23.8301 86.1514 41.7387 104.06 63.8301 104.06Z",
    stroke: "#cf000f",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1599 87.59C66.5237 87.59 68.4399 85.6738 68.4399 83.31C68.4399 80.9462 66.5237 79.03 64.1599 79.03C61.7961 79.03 59.8799 80.9462 59.8799 83.31C59.8799 85.6738 61.7961 87.59 64.1599 87.59Z",
    stroke: "#cf000f",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4302 70.93V38.93",
    stroke: "#cf000f",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedRed);
export default __webpack_public_path__ + "static/media/failedRed.4ef381a8d7e1572b02688af353b8d18c.svg";
export { ForwardRef as ReactComponent };